import "react";
import { cn } from "@synthesis/shared-utils";
import { jsx } from "react/jsx-runtime";
import { Menu } from "@base-ui/react/menu";
//#region src/Dropdown/Dropdown.lib.tsx
const dropdownItemPadding = {
	xs: "py-px pl-1",
	sm: "py-1.5 pl-1.5",
	md: "py-3 pl-2",
	lg: "py-3.5 pl-2.5"
};
const dropdownItemIconMargin = {
	xs: "mr-2",
	sm: "mr-2.5",
	md: "mr-3.5",
	lg: "mr-[18px]"
};
function DropdownItemWrapper({ disabled, size, children, className }) {
	return /* @__PURE__ */ jsx("div", {
		className: cn("bg-neutrals-white flex flex-row items-center justify-between px-2 py-3 pr-5 text-sm", "cursor-pointer", "group-data-[open]:bg-tertiary-95", "hover:bg-neutrals-95/90 hover:transition hover:duration-100", dropdownItemPadding[size], disabled && "bg-neutrals-90 font-sans text-sm", className),
		children
	});
}
function DropdownItemIconWrapper({ size, isActiveItem, children, className }) {
	return /* @__PURE__ */ jsx("div", {
		className: cn("text-neutrals-60 w-5", dropdownItemIconMargin[size], isActiveItem && "text-red-400", className),
		children
	});
}
function DropdownItemLabelWrapper({ isActiveItem, disabled, children, className, ...rest }) {
	return /* @__PURE__ */ jsx("div", {
		className: cn("mr-1 max-w-[250px] text-sm font-normal not-italic leading-6 text-neutral-900", isActiveItem && "text-red-400", disabled && "text-type-light", className),
		...rest,
		children
	});
}
function DropdownCheckboxWrapper({ checked, disabled, size, children, className }) {
	return /* @__PURE__ */ jsx("div", {
		className: cn("bg-neutrals-white flex flex-row items-center justify-between py-3 pl-3 pr-5 text-sm", "cursor-pointer transition duration-100", "hover:bg-neutrals-95/90 hover:transition hover:duration-100", dropdownItemPadding[size], checked && "bg-tertiary-95", disabled && "bg-neutrals-80 font-sans text-sm", className),
		children
	});
}
function CheckboxLabel({ disabled, children, className }) {
	return /* @__PURE__ */ jsx("span", {
		className: cn("cursor-pointer select-none text-sm font-normal not-italic leading-6 text-neutral-900", disabled && "text-type-light", className),
		children
	});
}
function CheckboxIcon({ children, className }) {
	return /* @__PURE__ */ jsx("div", {
		className: cn("relative h-5 w-5", className),
		children
	});
}
function StyledInputCheckbox({ disabled, checked, className, ...props }) {
	return /* @__PURE__ */ jsx("input", {
		className: cn("outline-system-info-70 m-0 h-full w-full cursor-pointer appearance-none rounded", checked && !disabled && "bg-brand-40 border-0", checked && disabled && "bg-neutrals-95 border-0", !checked && "border-neutrals-80 bg-neutrals-95 border-2 border-solid", className),
		...props
	});
}
function DropdownRadioItem({ isActive, className, children, disabled, ...props }) {
	return /* @__PURE__ */ jsx(Menu.RadioItem, {
		...props,
		disabled,
		className: cn("flex cursor-pointer items-center justify-between outline-none focus:outline-none focus-visible:outline-none", "hover:bg-neutrals-95", isActive && "bg-tertiary-95", disabled && "bg-neutrals-80", className),
		children
	});
}
function DropdownRadioItemWrapper({ size, children, className }) {
	return /* @__PURE__ */ jsx("div", {
		className: cn("flex w-full items-center justify-between py-3 pl-3 pr-5 outline-none", "hover:bg-neutrals-95/90 hover:transition hover:duration-100", dropdownItemPadding[size], className),
		children
	});
}
function StyledRadioItem({ disabled, children, className, ...rest }) {
	return /* @__PURE__ */ jsx("div", {
		className: cn("border-neutrals-80 bg-neutrals-95 flex size-5 shrink-0 items-center justify-center rounded-full border-2", "group-data-[checked]:border-brand-40 group-data-[checked]:bg-brand-40", "group-data-[disabled]:bg-neutrals-80", disabled && "border-neutrals-95 group-data-[checked]:border-neutrals-95 group-data-[checked]:bg-neutrals-95", className),
		...rest,
		children
	});
}
function StyledRadioIndicator({ className, children, ...props }) {
	return /* @__PURE__ */ jsx(Menu.RadioItemIndicator, {
		className: cn("flex h-full w-full items-center justify-center", className),
		...props,
		children
	});
}
function DropdownRadioLabel({ disabled, children, className }) {
	return /* @__PURE__ */ jsx("span", {
		className: cn("cursor-pointer select-none pr-2 text-sm font-normal leading-6 text-neutral-900", disabled && "text-type-light", className),
		children
	});
}
function DropdownSeparator({ className, ...props }) {
	return /* @__PURE__ */ jsx(Menu.Separator, {
		className: cn("bg-neutrals-80 h-px", className),
		...props
	});
}
function DropdownItemHotKeyWrapper({ children, className }) {
	return /* @__PURE__ */ jsx("div", {
		className: cn("text-type-light rounded px-1 outline outline-1 outline-slate-200", className),
		children
	});
}
//#endregion
export { CheckboxIcon, CheckboxLabel, DropdownCheckboxWrapper, DropdownItemHotKeyWrapper, DropdownItemIconWrapper, DropdownItemLabelWrapper, DropdownItemWrapper, DropdownRadioItem, DropdownRadioItemWrapper, DropdownRadioLabel, DropdownSeparator, StyledInputCheckbox, StyledRadioIndicator, StyledRadioItem };

//# sourceMappingURL=Dropdown.lib.js.map